import { useEffect } from 'react';
import type { FieldValues, UseFormReturn } from 'react-hook-form';

/** Reports the current values on mount and on every change, so a live preview can follow. */
export const useReportFormValues = <T extends FieldValues>(
  formMethods: UseFormReturn<T>,
  onFormValuesChange?: (values: T) => void,
) => {
  useEffect(() => {
    onFormValuesChange?.(formMethods.getValues());
    const { unsubscribe } = formMethods.watch((values) => {
      onFormValuesChange?.(values as T);
    });

    return () => {
      unsubscribe();
    };
  }, [formMethods, onFormValuesChange]);
};
